<template>
  <!-- Container -->
  <div class="w-11/12 mx-auto">
    <h2 class="big-title mb-14">
      Promotions
    </h2>
    <!-- Form container -->
    <div class="form-wrapper 2xl:w-9/12 mx-auto">
      <h3 class="form-title ">
        Create push notification
      </h3>

      <!-- Form -->
      <form @submit.prevent="onSubmit" class="text-tableSubColor font-bold">
        <div class="md:flex">
          <div class="md:w-full md:mr-8">
            <!-- Title -->
            <div class="w-full mb-4">
              <label
                >Title
                <input
                  type="text"
                  name="title"
                  autocomplete="off"
                  v-model="model.title"
                  class="input"
                  :class="{
                    'is-invalid': v$.model.title.$error,
                  }"
                />
              </label>
              <span
                v-if="v$.model.title.$error"
                class="text-sm font-normal text-invalidColor"
                >{{ v$.model.title.$errors[0].$message }}</span
              >
            </div>
            <!-- Select Status -->
            <div class="w-full mb-4">
              <label
                >Select Status
                <select
                  name="status"
                  v-model="model.status"
                  class="input"
                  :class="{
                    'is-invalid': v$.model.status.$error,
                  }"
                >
                  <option value="payment_failed">Payment failed</option>
                  <option value="pending">Pending</option>
                  <option value="processing">Processing</option>
                  <option value="preparing">Preparing</option>
                  <option value="ready">Ready</option>
                  <option value="delivering">Delivering</option>
                  <option value="completed">Completed</option>
                </select>
              </label>
              <span
                v-if="v$.model.status.$error"
                class="text-sm font-normal text-invalidColor"
                >{{ v$.model.status.$errors[0].$message }}</span
              >
            </div>
          </div>
          <!-- Body -->
          <div class="w-full mb-4">
            <label
              >Body
              <textarea
                rows="4"
                cols="30"
                name="body"
                v-model="model.body"
                class="input"
                :class="{
                  'is-invalid': v$.model.body.$error,
                }"
              ></textarea>
            </label>
            <span
              v-if="v$.model.body.$error"
              class="text-sm font-normal text-invalidColor"
              >{{ v$.model.body.$errors[0].$message }}</span
            >
          </div>
        </div>

        <div class="flex">
          <!-- Is Pickup -->
          <div class="flex flex-col md:ml-1 mr-8">
            <label for="is_pickup">Is Pickup</label>
            <label class="switch mb-4 md:mb-0 md:mt-2">
              <input
                type="checkbox"
                v-model="model.is_pickup"
                :false-value="parseInt(0)"
                :true-value="parseInt(1)"
              />
              <span class="slider round"></span>
            </label>
          </div>
          <!-- Published -->
          <div class="flex flex-col">
            <label for="published">Published</label>
            <label class="switch mb-4 md:mb-0 md:mt-2">
              <input
                type="checkbox"
                v-model="model.published"
                :false-value="parseInt(0)"
                :true-value="parseInt(1)"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <!-- Buttons -->
        <div class="w-full flex justify-end pt-4">
          <Button
            type="button"
            @click.prevent="back"
            btnTitle="Cancel"
            class="mr-4 bg-goldBeige text-black"
          />
          <Button type="submit" btnTitle="Save" class="bg-greenBtn" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Button from "../../../components/Button.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "PushNotificationsCreate",
  components: {
    Button,
  },
  data() {
    return {
      v$: useVuelidate(),
      model: {
        title: "",
        body: "",
        status: "",
        is_pickup: 0,
        published: 0,
      },
    };
  },

  /* --- Validation --- */
  validations() {
    return {
      model: {
        title: { required },
        body: { required },
        status: { required },
      },
    };
  },

  methods: {
    async onSubmit() {
      this.v$.$validate();
      if (!this.v$.$error) {
        try {
          await this.$store.dispatch("savePushNotification", this.model);
          //redirect
          this.$router.push("/push-notifications");
        } catch (e) {
          alert(Object.values(e.response.data.messages).join(" "));
        }
      }
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>
